// src/pages/personal/platforms/InstagramPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import InstagramSection from './InstagramSection/InstagramSection';

const InstagramPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <InstagramSection />
    </AdaptiveLayout>
  );
};

export default InstagramPage;